export const isLoadedInIframe = () => {
  console.log(window !== parent);
  return window !== parent;
};
